import React from "react";
import { css } from "emotion";
import { boxStyles } from "../../styles/theme";
import StatCardRow from "./StatCardRow";
import LiveSwitch from "./LiveSwitch";
import OverviewCardSingleView from "../OverviewCardSingleView";
import TargetingLink from "../targeting/TargetingLink";

const ViewBodyMobile = () => {
  return (
    <div className={container}>
      <OverviewCardSingleView />
      <StatCardRow />
      <TargetingLink />
      <LiveSwitch />
    </div>
  );
};

export default ViewBodyMobile;

const container = css`
  padding: ${boxStyles.standardPadding};
`;
